// sync with violation table in database for more details on the fields and their values
/*
 * Refer
 * DB: Exam Platform Project
 * Table: violations
 */
const violations = [
  {
    id: 1,
    warningCode: "WARN_HW_ALA",
    description: "Avoid looking around",
    isDeleted: false,
  },
  {
    id: 2,
    warningCode: "WARN_EW_EM",
    description: "Eye movement detected",
    isDeleted: false,
  },
  {
    id: 3,
    warningCode: "WARN_HW_LM",
    description: "Lip movement detected",
    isDeleted: false,
  },
  {
    id: 4,
    warningCode: "WARN_OD_MPD",
    description: "Multiple person detected",
    isDeleted: false,
  },
  {
    id: 5,
    warningCode: "WARN_HW_MF",
    description: "Multiple faces detected",
    isDeleted: false,
  },
  {
    id: 6,
    warningCode: "WARN_AW_SD",
    description: "Speech detected",
    isDeleted: false,
  },
  {
    id: 7,
    warningCode: "WARN_OD_CPD",
    description: "Cell phone detected",
    isDeleted: false,
  },
  {
    id: 8,
    warningCode: "WARN_HW_NF",
    description: "No face visible",
    isDeleted: false,
  },
  {
    id: 9,
    warningCode: "WARN_OD_LD",
    description: "Laptop detected",
    isDeleted: false,
  },
  {
    id: 10,
    warningCode: "WARN_OD_BD",
    description: "Book detected",
    isDeleted: false,
  },
  {
    id: 11,
    warningCode: "WARN_OD_ED",
    description: "Earbuds detected",
    isDeleted: false,
  },
  {
    id: 12,
    warningCode: "WARN_OD_HD",
    description: "Headphones detected",
    isDeleted: false,
  },
  {
    id: 13,
    warningCode: "TAB_SWITCH",
    description: "Tab Switch detected",
    isDeleted: false,
  }
];

export default violations;
